import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/PlataformaNoAccess";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/plataforma/no-access")({
  head: () =>
    pageHead({ title: "Acesso Não Ativo | Plataforma | Clara Camille", path: "/plataforma/no-access", noindex: true }),
  component: Page,
});
